import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=5aa18d3e&scoped=true&"
import script from "./NotesCard.vue?vue&type=script&lang=ts&"
export * from "./NotesCard.vue?vue&type=script&lang=ts&"
import style0 from "./NotesCard.vue?vue&type=style&index=0&id=5aa18d3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa18d3e",
  null
  
)

export default component.exports